export function patchProp(el, key, prevValue, nextValue, isSVG, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    getSetter(key)(el, nextValue);
}
const obj = {};
const getSetter = (key) => {
    if (!obj[key]) {
        obj[key] = new Function("el", "value", `el["${key}"] = value`);
    }
    return obj[key];
};
//# sourceMappingURL=patchProp.js.map